import React from "react";

function FoodPhotosItem(props) {

    const {
        id,
        photoName,
        alt,
        title,
        text1,
        onClickEdit,
        onClickEditEng,
        onClickEditFra,
        onClickEditGer,
        onClickEditDut,
        onClickDelete
    } = props;

    return (
        <div className="card" style={{ marginTop: "100px" }}>
            <div className="card-body">
                <div className="d-flex align-items-center justify-content-between mt-5">
                    <div className="lesson_name" style={{ marginTop: "100px" }}>
                        <div className="project-block w-100">
                            <img src={process.env.PUBLIC_URL + `/uploads/food_photos/${photoName}`} style={{ width: "40%", borderRadius: "8px" }} />
                        </div>
                    </div>
                    <div className="btn-group mt-4" role="group" aria-label="Basic outlined example">
                        <button type="button" className="btn btn-outline-secondary" onClick={onClickEdit}>
                            <i className="icofont-edit text-success"></i>
                        </button>
                        <button
                            type="button"
                            className="btn btn-outline-secondary"
                            title="İngilizce Güncelleme"
                            onClick={onClickEditEng}
                        >
                            <img src={process.env.PUBLIC_URL + `/flags/united-kingdom.png`} style={{ width: "15px" }} />
                        </button>
                        <button
                            type="button"
                            className="btn btn-outline-secondary"
                            title="Fransızca Güncelleme"
                            onClick={onClickEditFra}
                        >
                            <img src={process.env.PUBLIC_URL + `/flags/france.png`} style={{ width: "15px" }} />
                        </button>
                        <button
                            type="button"
                            className="btn btn-outline-secondary"
                            title="Almanca Güncelleme"
                            onClick={onClickEditGer}
                        >
                            <img src={process.env.PUBLIC_URL + `/flags/germany.png`} style={{ width: "15px" }} />
                        </button>
                        <button
                            type="button"
                            className="btn btn-outline-secondary"
                            title="Felemenkçe Güncelleme"
                            onClick={onClickEditDut}
                        >
                            <img src={process.env.PUBLIC_URL + `/flags/netherlands.png`} style={{ width: "15px" }} />
                        </button>
                        <button type="button" className="btn btn-outline-secondary" onClick={onClickDelete}>
                            <i className="icofont-ui-delete text-danger"></i>
                        </button>
                    </div>
                </div>
                <div className="row g-2 pt-4">
                    <div className="col-12">
                        <h6 className="mb-0 fw-bold  fs-6  mb-2">{title}</h6>
                        <div className="d-flex align-items-center">
                            <span className="ms-2">{text1}</span>
                        </div>
                    </div>
                </div>
            </div>
            <div className="d-flex align-items-center justify-content-start p-3 border-top">
                <div className="text-primary">{"SEO => "}</div>
                <span className="ms-2">{alt}</span>
            </div>
        </div>
    )
}


export default FoodPhotosItem;